import "./Faq.module.css";
import TrendMitraNavigationHeader from "@/reusable_sections/Header";
import KnowledgeBase from "./sections/KnowledgeBase";
import StillHaveQuestions from "./sections/StillHaveQuestions";
import TerminalFooter from "@/reusable_sections/Footer";
export default function FaqPage() {
  return <div>
      <TrendMitraNavigationHeader />
      <KnowledgeBase />
      <StillHaveQuestions />
      <TerminalFooter />
    </div>;
}